import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

function ChunkPickerDoublePageButton(props) {
  const { onClick, iconClassName, min, max, current } = props;
  const isLeftButton = iconClassName === 'left';

  const handleFirstButtonClick = () => {
    const targetPage = isLeftButton ? min : current + 1;
    return onClick(targetPage);
  };

  const handleLastButtonClick = () => {
    const targetPage = isLeftButton ? current - 1 : max;
    return onClick(targetPage);
  };

  const showFirstButton = isLeftButton ? true : max !== current;
  const showLastButton = isLeftButton ? min !== current : true;

  return (
    <div>
      {showFirstButton && (
        <Button
          onClick={handleFirstButtonClick}
          buttonConfig={{
            type: 'link',
            size: 'md',
            className: 'chunk-picker-double-page-button',
            e2eName: `chunk-picker-double-page-button-${iconClassName}-first`,
            ariaLabel: `Chunk picker ${iconClassName} first`,
          }}>
          <span className="rx-btn-icon">
            <i className={isLeftButton ? `ss-navigate${iconClassName} special first` : `ss-navigate${iconClassName}`} />
          </span>
        </Button>
      )}
      {showLastButton && (
        <Button
          onClick={handleLastButtonClick}
          buttonConfig={{
            type: 'link',
            size: 'md',
            className: 'chunk-picker-double-page-button',
            e2eName: `chunk-picker-double-page-button-${iconClassName}-last`,
            ariaLabel: `Chunk picker ${iconClassName} last`,
          }}>
          <span className="rx-btn-icon">
            <i className={isLeftButton ? `ss-navigate${iconClassName}` : `ss-navigate${iconClassName} special last`} />
          </span>
        </Button>
      )}
    </div>
  );
}

ChunkPickerDoublePageButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  iconClassName: PropTypes.oneOf(['left', 'right']),
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
};

export default ChunkPickerDoublePageButton;
